module.exports = __webpack_public_path__ + "img/signup.c5bd4fd5.jpg";